export interface MvMRosterCharacter {
  instanceId: string
  templateId: string
  name: string
}

export interface MvMOffenseJoiner {
  walletAddress: string
  displayName: string
  /** Profile image from server (`/mvm/pending-rosters`). */
  avatarUrl?: string
  joinedAt?: string
  characters: MvMRosterCharacter[]
  /**
   * This ally's OWN return march while the row is `returning` (server `allyReturnMarches`). Absent on
   * legacy rows, where the joiner rode home with the leader. Their lock ends when THIS lands, not the leader's.
   */
  returnArrivesAt?: string
  returnStatus?: 'returning' | 'completed'
}

export interface MvMOffenseRoster {
  attackId: string
  arrivesAt?: string
  /** Home arrival while `status === 'returning'` (mirror pending attack). */
  returnArrivesAt?: string
  status?: string
  rallyMode?: boolean
  leader: {
    walletAddress: string
    displayName: string
    avatarUrl?: string
    characters: MvMRosterCharacter[]
  }
  joiners: MvMOffenseJoiner[]
}

export interface MvMDefenseRoster {
  attackId: string
  arrivesAt?: string
  returnArrivesAt?: string
  status?: string
  defenderAttackerBusyAutoDefense?: boolean
  castleOwner: {
    walletAddress: string
    displayName: string
    avatarUrl?: string
    hasSelectedDefenders?: boolean
    characters: MvMRosterCharacter[]
  }
  reinforcements: MvMOffenseJoiner[]
}

export interface MvMPendingAttackEntry {
  attackId: string
  /** Target hex (when provided by `/mvm/pending-rosters`, same sense as world-map pending attacks). */
  toQ?: number
  toR?: number
  fromQ?: number
  fromR?: number
  arrivesAt?: string
  /** Present when troops march home after battle (`status` often `returning`). */
  returnArrivesAt?: string
  status?: string
  /** Server set: castle owner was busy as MvM attacker — auto roster, no manual defend UI */
  defenderAttackerBusyAutoDefense?: boolean
  offense?: MvMOffenseRoster
  defense?: MvMDefenseRoster
}

export interface MvMRosterState {
  byAttackId: Record<string, MvMPendingAttackEntry>
}

export const initialMvMRosterState: MvMRosterState = {
  byAttackId: {},
}
